// extracted by mini-css-extract-plugin
export default {"root":"bg_root__HHGFg","imgBox":"bg_imgBox__Q8h2J"};